import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost/api'

export const getCreatePayeeAndTax = (projectCode) => {
  const url = `${API_ROOT}/v1/accounting/payee-tax/${projectCode}`
  return doGet(url)
}

export const saveCreatePayeeAndTax = (projectCode, request) => {
  const url = `${API_ROOT}/v1/accounting/payee-tax/${projectCode}`
  return doPost(url, request)
}

export const deleteCreatePayeeAndTax = (projectCode, id) => {
  const url = `${API_ROOT}/v1/accounting/payee-tax/${projectCode}/${id}`
  return doDelete(url)
}

export const editCreatePayeeAndTax = (projectCode, id) => {
  const url = `${API_ROOT}/v1/accounting/payee-tax/${projectCode}/id/${id}`
  return doGet(url)
}

export const searchCreatePayeeAndTax = (projectCode, request) => {
  const url = `${API_ROOT}/v1/accounting/payee-tax/${projectCode}/search?taxId=${request.taxId || ''}&name=${request.name || ''}&email=${request.email || ''}&phoneNumber=${request.phoneNumber || ''}&projectcode=${projectCode || ''}`
  return doGet(url)
}
